export default __webpack_public_path__ + "static/media/Gray-Poly-Popup3.3c05db75.png";